import React, { Component, useEffect } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as actions from "../../redux/actions/auth/index";

const ConnexionRequise = (props) => {
    const { logout } = props;
    const intl = useIntl();
    useEffect(()=>{
      logout();
    },[]);
    const codePermUrl = intl.formatMessage({ id: "error.status_401.codeperm_url" });
    const codePermLinkText = intl.formatMessage({ id: "error.status_401.codeperm_link" });
    return (
      <div id='error' className='page'>
        <section>
          <h1>
            <FormattedMessage id='error.status_401.title' />
          </h1>
          <p>
            <FormattedMessage id='error.status_401.p1' />
          </p>
          <p>
            <FormattedMessage id='error.status_401.intro' />
          </p>
          <div className='call-out call-out-info'>
            <p>
              <FormattedMessage id='error.status_401.email_option' values={{
                b: (chunks) => <strong>{chunks}</strong>
              }} />
            </p>
          </div>
          <p className='codeperm-fallback text-muted text-small'>
            <FormattedMessage id='error.status_401.codeperm_option' values={{
              CodePermLoginLink: <a className='subtle' href={codePermUrl}>{codePermLinkText}</a>
            }} />
          </p>
        </section>
      </div>
    );
  }

export default connect(null, actions)(ConnexionRequise);
